var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"insight-panel",class:_vm.openModifier},[_c('div',{staticClass:"insight-panel__wrap"},[_vm._t("default")],2),_vm._v(" "),(_vm.showBottom)?_c('div',{staticClass:"insight-panel__bottom"},[_c('span',{staticClass:"insight-panel__link",class:_vm.moreModifier,on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.text))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60aa162c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/insight/insight-panel/insight-panel.vue
// module id = MRk1
// module chunks = 0